import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={82}
    height={48}
    fill="none"
    viewBox="0 0 82 48"
    {...props}
  >
    <path fill="#E5E5E5" d="M14.555 42.416v.239s.068-.24 0-.24" />
    <path
      fill="#E5E5E5"
      d="M42.606 3.705A3.79 3.79 0 0 0 38.882.288c-13.257 0-27.88.444-29.623 2.7A37.6 37.6 0 0 0 .717 18.397a9.7 9.7 0 0 0-.546 4.749 3.96 3.96 0 0 0 2.22 2.289c2.348.304 4.725.304 7.073 0 .24.099.51.099.752 0-.376 9.362-1.06 15 1.469 19.236 1.196 1.947 16.332 2.836 16.605 2.836s38.3.478 38.608.444a15.34 15.34 0 0 0 8.781-2.973c2.118-1.742 1.606-10.557 1.196-16.57 0-2.563-2.46-1.846-2.426 0 0 2.494.17 5.261 0 7.79 0 1.195-.273 6.833-.752 6.628-5.876 4.441-19.133 0-30.408.444 0-.308 0 2.016.24-10.66.375-9.532-.48-22.687-.923-28.905M10.25 23.078a33 33 0 0 0-5.877-.342c-2.323-.342-.205-3.075 0-3.417a78.6 78.6 0 0 1 6.184-14.213c0 1.059.274 2.289.274 3.109zM40.385 3.5c0 .376.58 35.738.752 39.668-8.867.447-17.755.195-26.582-.752a13.3 13.3 0 0 1-1.264-4.442c-.342-2.699 0-3.997-.274-29.793 0-1.093-.512-2.836-.41-4.032 16.025-2.562 11.788 1.06 29.213-.478"
    />
    <path
      fill="#E5E5E5"
      d="M49.063 23.59c1.435 1.093 27.607 2.016 27.573 1.606.98.256 2.003.314 3.006.17A2.665 2.665 0 0 0 82 22.566a47 47 0 0 0-2.46-10.49 31.2 31.2 0 0 0-2.46-6.627 1.207 1.207 0 0 0-1.914 1.469 36 36 0 0 1 1.845 6.184q.449 1.415.752 2.87c1.503 7.14.513 4.236.718 6.389a33 33 0 0 0-3.861-.82c-20.159-.24-23.131-.376-23.507-.478-.957.649-3.417-11.856-4.886-17.391 4.75 0 9.806.273 14.555.615a95 95 0 0 1 14.35.854 1.007 1.007 0 0 0 .513-1.947A109 109 0 0 0 61.09 1.245C59.176.972 53.573.63 45.886.493a2.118 2.118 0 0 0-2.119 2.631z"
    />
  </svg>
);
export default SvgEmptyBox;
